import { AutoMap } from "@automapper/classes"

export class ELIMSTestDTO {
    @AutoMap()
    testCode: string = ''
    @AutoMap()
    testName: string = ''
    @AutoMap()
    parameterCode: string = ''
    @AutoMap()
    parameterName: string = ''
    @AutoMap()
    productEurodat5Code: string = ''
    @AutoMap()
    partnerCode: string = ''
    @AutoMap()
    elimsUnitName: string = ''
    @AutoMap()
    cas : string = ''
    @AutoMap()
    incertitudeLOQ! : number
    @AutoMap()
    loq! : number
    @AutoMap()
    method : string = ''
}